<template>

    <body id="poster">
        <el-form :class="isJump?'animate__animated animate__fadeOutRight login-container':'animate__animated animate__fadeInLeft login-container'" label-position="left" label-width="0px">
            <!-- <img src="../assets/images/Leica_RGB.jpg" style="width:60px;height:60px;margin-left:-2px;"> -->
            <h2 class="login_title">{{$t('message.title')}}</h2>
            <el-form-item>
                <el-input type="text" v-model="loginForm.Account" auto-complete="off" :placeholder="$t('message.uname')" @keyup.enter.native="Login()"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input type="password" v-model="loginForm.PassWord" auto-complete="off" :placeholder="$t('message.password')" show-password @keyup.enter.native="Login()"></el-input>
            </el-form-item>
            <el-form-item>
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{$t('message.selectlang')}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="2">{{$t('message.selectop1')}}</el-dropdown-item>
                        <el-dropdown-item command="1">{{$t('message.selectop2')}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-form-item>
            <el-form-item style="width: 100%">
                <el-button type="primary" style="width: 100%;background: #505458;border: none" v-on:click="Login">{{$t('message.login')}}</el-button>
            </el-form-item>
        </el-form>
        <div style="
    position: absolute;
    top: 96%;
    width:100%;
    height:65px;
    background:black">
            <center style="color:white;margin:5px;"><span><a style="text-decoration:none;color:white;fon-size:12pt" href="https://beian.miit.gov.cn/" target="blank">工业和信息化部备案管理系统网站&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沪ICP备15035098号&nbsp;&nbsp;&nbsp;</a><a style="text-decoration:none;color:white;fon-size:12pt" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502016703" target="blank"><img src="../components/Pic/ba.png" height="12px;">沪公网安备 31011502016703号</a>&nbsp;&nbsp;&nbsp;&nbsp;Copyright© 2021 上海焕云网络技术有限公司</span></center>
            <!-- <center style="color:white;margin:5px;"><a style="text-decoration:none;color:white;fon-size:12pt" href="https://beian.miit.gov.cn/" target="blank">工业和信息化部备案管理系统网站&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沪ICP备15035098号</a><span style="margin-left:30px">Copyright© 2021 上海焕云网络技术有限公司</span></center>  -->
        </div>
        <!-- <div style="width:100%;margin:0 auto; padding:20px 0; position: absolute;
    top: 95%;">
		 	<center>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502016703" 
       style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/>
       <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31011502016703号</p>
       </a>
		 	</center>
	</div> -->
    </body>
</template>
<script>
import { mapMutations } from "vuex";
import Cookie from "js-cookie";
let Base64 = require("js-base64").Base64;
export default {
    name: "Login",
    data() {
        return {
            loginForm: {
                Account: "",
                PassWord: "",
                loginLanguage: 1,
            },
            isJump: false,
        };
    },  
    computed: {
        rules() {
            return {
                password: [
                    {
                        required: true,
                        message: this.$t("message.upassword"),
                        trigger: "blur",
                    },
                ],
            };
        },
    },
    methods: {
        ...mapMutations(["setToken"]),
        handleCommand(command) {
            switch (command) {
                case "2": {
                    this.lang = "cn";
                    this.$i18n.locale = this.lang;
                    this.loginForm.loginLanguage = 1;
                    break;
                }
                case "1": {
                    this.lang = "en";
                    this.$i18n.locale = this.lang;
                    this.loginForm.loginLanguage = 2;
                    break;
                }

                default:
                    break;
            }
            localStorage.lang = this.lang;
        },
        Login() {
            let _this = this;
            if (
                _this.loginForm.Account == "" ||
                _this.loginForm.PassWord == ""
            ) {
                _this.$message.error("请输入账号和密码");
            } else {
                this.$http
                    .post(
                        this.baseurl.baseURL + "/Api/Login/GetWebLoginToken",
                        {
                            Account: this.loginForm.Account,
                            PassWord: Base64.encode(this.loginForm.PassWord),
                            loginLanguage: this.loginForm.loginLanguage,
                        }
                    )
                    .then((res) => {
                        console.log(res);
                        var code = res.data.Code;
                        var mes = res.data.Msg;

                        if (this.$i18n.locale == "en") {
                            mes = res.data.EnMsg;
                        }
                        if (code == 200) {
                            // localStorage.removeItem('token');
                            // this.setToken({token: res.data.Data.Token});
                            window.sessionStorage.setItem(
                                "token",
                                res.data.Data.Token
                            );
                            window.sessionStorage.setItem(
                                "loginName",
                                res.data.Data.CnName
                            );
                            //window.sessionStorage.setItem('loginId',res.data.Data.entity.Account)

                            var storage = window.sessionStorage;
                            if (storage.token) {
                                this.isJump = true;
                                setTimeout(() => {
                                    console.log(storage.Token);
                                    this.$router.push({ path: "Home" });
                                    var mesdata = "登录成功";
                                    if (this.$i18n.locale == "en") {
                                        mesdata = "Login succeeded";
                                    }
                                    _this.$message.success(mesdata);
                                }, 500);
                            } else {
                                this.$router.replace("/Login");
                            }
                        } else {
                            _this.$message.error(mes);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        _this.$message.error(
                            "登录错误，请联系程序开发人员！！"
                        );
                    });
            }
        },
    },
};
</script>
<style>
#poster {
    background: url("../components/Pic/bj.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
}
body {
    margin: 0px;
    padding: 0;
}

.login-container {
    border-radius: 15px;
    background-clip: padding-box;
    margin: 90px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
}

.login_title {
    /* margin: -40px auto 40px auto; */
    text-align: center;
    color: #505458;
}
</style>




// WEBPACK FOOTER //
// src/components/Login.vue